module.exports = __webpack_public_path__ + "img/icon_star_rate_active_noborder.195ba25d.svg";